module.exports = __webpack_public_path__ + "assets/img/newApiNoBg.8a196e07.svg";